export enum CidadeOrigemTypes {
  'LOAD_REQUEST' = '@cidadeOrigem/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@cidadeOrigem/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@cidadeOrigem/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@cidadeOrigem/CLEAN_MOVIENTRADA',
}
export interface ICidadeOrigem {
  codCid: number;
  codUf: number;
  nome: string;
}

export interface CidadeOrigemState {
  readonly data: ICidadeOrigem[];
  readonly loading: boolean;
  readonly error: boolean;
}
